<template>
  <div class="salary-tmp">
    <div class="salary-tmp-content">
      <div v-if="dynamicTags.length > 0" class="add-salary-tmp">
        <i v-show="isShowArrow" class="el-icon-arrow-left" @click="pro"></i>
        <div class="salary-tmp-name" id="salarytmpname">
          <div id="swiper">
            <el-tag
              v-for="(item, index) in dynamicTags"
              :key="index"
              :class="{ active: activeIndex == index }"
              :closable="activeIndex == index"
              @click="selectTag(index, item, $event)"
              @close="handleCloseTag(item.id)"
            >
              <span class="tag-name">
                {{ item.name }}
              </span>
            </el-tag>
          </div>
        </div>
        <i v-show="isShowArrow" class="el-icon-arrow-right" @click="next"></i>
        <div
          v-if="
            OPERATION_LIST.findIndex(
              (item) => item === OPERATIONS_BTNS.roleAddSalaryTemplate
            ) !== -1
          "
          class="tmp-btn"
        >
          <el-button
            class="btn-white"
            size="small"
            @click="openModSalaryTmp"
            >编辑</el-button
          >
          <el-button
            class="btn-blue"
            size="small"
            @click="openAddSalaryTmp"
            >新建模板</el-button
          >
        </div>
      </div>
      <div class="salary-tmp-container" v-if="dynamicTags.length > 0">
        <div class="left-container" v-if="typeList.length > 0">
          <div class="add-type-content">
            <div>
              <div
                :class="activeTypeIndex === index ? 'active type' : 'type'"
                v-for="(item, index) in typeList"
                :key="index"
                @click="selectType(index, item)"
              >
                <div class="type-title">
                  <img src="../../../../assets/tree/random.png" />
                  <div>{{ item.name }}</div>
                </div>
                <el-dropdown
                  v-if="
                    OPERATION_LIST.findIndex(
                      (item) =>
                        item ===
                        OPERATIONS_BTNS.roleDelRenameAddSalaryTemplateCategory
                    ) !== -1
                  "
                  trigger="click"
                  @command="handleCommand"
                >
                  <span class="el-dropdown-link">
                    <img src="../../../../assets/tree/three-spot.png" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      :command="beforeHandleCommand(item, 'mod')"
                      class="mod"
                      >重命名</el-dropdown-item
                    >
                    <el-dropdown-item
                      :command="beforeHandleCommand(item, 'delete')"
                      class="delete"
                      >删除</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
          <el-button
            v-if="
              OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleDelRenameAddSalaryTemplateCategory
              ) !== -1
            "
            type="text"
            class="btn-border-text-blue add-type"
            @click="openAddType"
            >新增分类</el-button
          >
        </div>
        <div class="right-container" v-if="typeList.length > 0">
          <div class="top-container">
            <div class="title">细项表格</div>
            <div class="search">
              <el-button
                v-if="
                  OPERATION_LIST.findIndex(
                    (item) => item === OPERATIONS_BTNS.roleAddDetails
                  ) !== -1
                "
                type="text"
                class="btn-blue add"
                icon="el-icon-plus"
                @click="openAddDetail"
                >添加</el-button
              >
            </div>
          </div>
          <div class="table" v-if="tableData.length > 0">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column
                v-for="(item, index) in tableTitleList"
                :key="index"
                :prop="item.prop"
                :label="item.lable"
                :width="item.width"
                :show-overflow-tooltip="item.showOverflowTooltip"
              />
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <div v-if="scope.row.contentList != undefined">
                    <i
                      v-if="
                        OPERATION_LIST.findIndex(
                          (item) =>
                            item ===
                            OPERATIONS_BTNS.roleUpdateInterpretationContent
                        ) !== -1
                      "
                      class="el-icon-edit"
                      @click="mod(scope.row)"
                    ></i>
                    <i class="el-icon-delete" @click="remove(scope.row.id)"></i>
                  </div>
                  <div v-else>---</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="nothing tmpType" v-if="typeList.length == 0">
          <div class="nothing-left">
            <div class="nothing-title">工薪模块</div>
            <p class="nothing-tips">
              你可以自由创建模板分类，并任意添加一个或多个细项。通过和管理后台其他功能
              结合，可以实现灵活的工资条管控
            </p>
            <el-button type="text" class="btn-blue add" @click="openAddType"
              >新建分类</el-button
            >
          </div>
          <img
            class="tmpType-nothing"
            src="../../../../assets/tmpType-nothing.png"
          />
        </div>

        <el-drawer
          :visible.sync="drawer"
          :size="400"
          :modal="false"
          :with-header="false"
          :wrapperClosable="false"
        >
          <div class="drawer-title">
            <i class="el-icon-close" @click="closeDrawer"></i>
            <div>
              <el-button type="text" class="btn-gray" @click="closeDrawer"
                >取消</el-button
              >
              <el-button
                type="text"
                class="btn-blue"
                @click="submitForm('ruleForm')"
                >保存</el-button
              >
            </div>
          </div>
          <div class="sub-title">
            {{ isModDetails ? "编辑细项" : "添加细项" }}
          </div>
          <el-form
            :model="ruleForm"
            :rules="ruleFormRules"
            ref="ruleForm"
            class="demo-ruleForm"
          >
            <el-form-item label="细项名称" prop="detailsName">
              <el-input
                class="gray white"
                v-model="ruleForm.detailsName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="细项类型" prop="detailsType">
              <el-select
                v-model="ruleForm.detailsType"
                placeholder="请选择"
                class="gray white"
              >
                <el-option
                  v-for="item in detailsTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="ruleForm.detailsType == 'Customize'"
              label="解读内容"
            >
              <el-input
                type="textarea"
                placeholder="请输入详细内容"
                v-model="ruleForm.textarea"
                :autosize="{ minRows: 5, maxRows: 5 }"
                resize="none"
                maxlength="100"
                show-word-limit
              >
              </el-input>
            </el-form-item>
            <div v-if="ruleForm.detailsType == 'Label'">
              <div class="label-title">
                <div>解读内容</div>
                <div class="add-label-title" @click="addLabelTitle">添加标签</div>
              </div>
              <div
                class="unscramble"
                v-for="(item, index) in ruleForm.unscrambleList"
                :key="index"
              >
                <i class="el-icon-error" @click="delLabelTitle(index)"></i>
                <div>标签名称：{{ item.content }}</div>
                <div class="amount">
                  <p>金额：{{ item.amount }}</p>
                  <i class="el-icon-edit" @click="modLabelTitle(item, index)"></i>
                </div>
              </div>
            </div>
          </el-form>
        </el-drawer>
      </div>

      <div class="nothing" v-if="dynamicTags.length == 0">
        <div class="nothing-left">
          <div class="nothing-title">工薪模块</div>
          <p class="nothing-tips">
            你可以自由创建模板分类，并任意添加一个或多个细项。通过和管理后台其他功能
            结合，可以实现灵活的工资条管控
          </p>
          <el-button type="text" class="btn-blue add" @click="openAddSalaryTmp"
            >新建模板</el-button
          >
        </div>
        <img class="tmp-nothing" src="../../../../assets/tmp-nothing.png" />
      </div>
    </div>

    <!-- 新增模板、新增分类、编辑解读内容和重命名分类名称 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item
          v-if="isFlag == 1 || isFlag == 6"
          label="模板名称"
          prop="tmpName"
        >
          <el-input
            class="gray white"
            v-model="form.tmpName"
            placeholder="请输入模板名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="isFlag == 1 || isFlag == 6"
          label="模板所属"
          prop="thirdDeptment"
        >
          <el-select
            v-model="form.thirdDeptment"
            placeholder="请选择"
            class="gray white"
          >
            <el-option
              v-for="item in thirdDeptmentList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="isFlag == 2 || isFlag == 3" class="add-type">
          <el-form-item label="分类名称" prop="typeName">
            <el-input class="gray white" v-model="form.typeName"></el-input>
          </el-form-item>
          <el-tooltip
            v-if="isFlag == 2"
            class="tooltip"
            effect="dark"
            placement="right"
          >
            <div slot="content">
              <p>选择增量，则各项进行相加</p>
              <br />
              <p>选择减量，则各项进行扣减</p>
            </div>
            <img src="../../../../assets/title.png" />
          </el-tooltip>
          <el-form-item v-if="isFlag == 2" label="计算规则" prop="ruleType">
            <el-select
              v-model="form.ruleType"
              placeholder="请选择"
              class="gray white"
            >
              <el-option
                v-for="item in ruleTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div v-if="isFlag == 4 || isFlag == 5">
          <el-form-item label="标签名称" prop="content">
            <el-input class="gray white" v-model="form.content"></el-input>
          </el-form-item>
          <el-form-item label="金额" prop="amount">
            <el-input
              class="gray white"
              v-model="form.amount"
              @input="inputAmount(form.amount)"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { config } from "@/common/js/config.js";
import { operationMixins } from "@/common/mixins/operation/operation.js";
import { handleAmount, inputTwoDecimal } from "@/common/js/utils.js";
import Salary from "@/models/salary.js";
export default {
  mixins: [operationMixins],
  data() {
    return {
      /* 模板id */
      salaryTemplateId: "",
      /* 分类id */
      salaryCategoryId: "",
      /* 细项id */
      detailsId: "",
      /* 选择模块的名称 */
      salaryTemplateName: "",
      /* 模板所属3级部门id */
      groupId: "",
      activeIndex: 0,
      dynamicTags: [],
      activeTypeIndex: 0,
      searchType: "",
      /* 分类集合 */
      typeList: [],
      /* 分类id */
      typeId: "",
      ruleTypeList: [
        { id: "Increment", name: "增量" },
        { id: "Decrease", name: "减量" },
      ],
      tableData: [],
      tableTitleList: [
        {
          prop: "name",
          lable: "细项名称",
          width: "",
          showOverflowTooltip: false,
        },
        {
          prop: "typeVal",
          lable: "类型",
          width: "",
          showOverflowTooltip: false,
        },
        {
          prop: "contentVal",
          lable: "解读内容",
          width: "",
          showOverflowTooltip: true,
        },
      ],
      /* 是否开启抽屉 */
      drawer: false,
      /* 是否编辑细项; 1.是; 0.否*/
      isModDetails: "",
      detailsTypeList: [
        { id: "Label", name: "标签设定" },
        { id: "Customize", name: "自定义设定" },
      ],
      detailsTypeObj: {
        Label: "标签设定",
        Customize: "自定义设定",
      },
      /* 解读内容下标 */
      unscrambleIndex: "",
      ruleForm: {
        detailsName: "",
        detailsType: "Label",
        textarea: "",
        unscrambleList: [],
      },
      ruleFormRules: {
        detailsName: [
          { required: true, message: "请输入细项名称", trigger: "blur" },
        ],
      },
      dialogTitle: "新增模板",
      dialogVisible: false,
      /* 1:新增模板; 2:新增分类; 3:重命名分类名称;
      4:编辑解读内容; 5:添加解读内容; 6:编辑模板 */
      isFlag: 1,
      /* 制表人所管理的三级部门 */
      thirdDeptmentList: [],
      form: {
        tmpName: "",
        thirdDeptment: "",
        typeName: "",
        ruleType: "",
        content: "",
        amount: "",
      },
      rules: {
        tmpName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        thirdDeptment: [
          { required: true, message: "请选择模板所属部门", trigger: "change" },
        ],
        typeName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        content: [{ required: true, message: "请输入名称", trigger: "blur" }],
        amount: [{ required: true, message: "请输入金额", trigger: "blur" }],
        ruleType: [
          { required: true, message: "请选择计算规则", trigger: "change" },
        ],
      },
      // 滚动条移动的距离
      spanLeft: 0,
      // 是否展示箭头
      isShowArrow: false
    };
  },

  created() {
    config();
    this.initTmpList();
    this.initThirdDeptment();
  },

  mounted() {
    document.getElementById("content").style.padding = 0 + "px";
  },
  destroyed() {
    document.getElementById("content").style.padding = 20 + "px";
    document.getElementById("content").style.paddingBottom = 0 + "px";
  },

  methods: {
    /* 获取模板列表 */
    initTmpList() {
      Salary.getSalaryTmpList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            obj.groupId = i.groupId;
            arr.push(obj);
          });
          this.dynamicTags = arr;
          this.salaryTemplateName = arr.length > 0 ? arr[0].name : "";
          this.groupId = arr.length > 0 ? arr[0].groupId : "";
          this.salaryTemplateId = arr.length > 0 ? arr[0].id : "";
          if (this.salaryTemplateId) this.initSalaryTypeList();
          // 屏幕总宽度
          const totalWidth = document.body.clientWidth
          // 获取salary-tmp-name盒子可以展示的模板名称数量
          const boxWidth = parseInt((totalWidth-449)/140)
          if (this.dynamicTags.length >= boxWidth) {
            this.isShowArrow = true
          } else {
            this.isShowArrow = false
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 获取制表人所管理的三级部门 */
    initThirdDeptment() {
      Salary.getThirdDeptment().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            arr.push(obj);
          });
          this.thirdDeptmentList = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 获取分类列表 */
    initSalaryTypeList() {
      let salaryTemplateId = this.salaryTemplateId;
      Salary.getSalaryTypeList(salaryTemplateId).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            obj.ruleType = i.ruleType;
            obj.salaryTemplateId = i.salaryTemplateId;
            obj.itemList = [];
            i.itemList.map((val) => {
              let obj3 = {};
              obj3.id = val.id;
              obj3.name = val.name;
              obj3.salaryCategoryId = val.salaryCategoryId;
              obj3.type = val.type;
              obj3.typeVal = this.detailsTypeObj[val.type];
              obj3.contentId = val.contentList[0].id;
              if (val.type == 'Customize') {
                obj3.contentVal = `${
                  handleAmount(val.contentList[0].amount, 2) == 0
                    ? ""
                    : `${handleAmount(val.contentList[0].amount, 2)}；`}${val.contentList[0].content}`;
              } else {
                obj3.contentVal = `${
                  `${handleAmount(val.contentList[0].amount, 2)}；`}${val.contentList[0].content}`;
              }
              obj3.contentList = [];
              val.contentList.map((v) => {
                let obj2 = {};
                obj2.name = "---";
                obj2.typeVal = "---";
                obj2.amount = handleAmount(v.amount, 2);
                if (val.type == 'Customize') {
                  obj2.contentVal = `${
                    handleAmount(v.amount, 2) == 0
                      ? ""
                      : `${handleAmount(v.amount, 2)}；`
                  }${v.content}`;
                } else {
                  obj2.contentVal = `${
                    `${handleAmount(v.amount, 2)}；`
                  }${v.content}`;
                }
                obj2.content = v.content;
                obj2.id = v.id;
                obj2.contentId = v.id;
                obj2.salaryItemId = v.salaryItemId;
                obj3.contentList.push(obj2);
              });
              obj.itemList.push(obj3);
            });
            arr.push(obj);
          });
          this.typeList = arr;
          this.tableData = this.treeToArray(arr[this.activeTypeIndex].itemList);
          this.salaryCategoryId = arr[this.activeTypeIndex].id;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    handleCloseTag(id) {
      this.$confirm("模板删除后不可恢复，是否继续？", "确认删除模板", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        this.delSalaryTmp(id);
      });
    },

    /* 删除模板 */
    delSalaryTmp(id) {
      let data = {
        id,
      };
      Salary.postDelSalaryTmp(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "模板删除成功",
          });
          this.activeIndex = 0
          this.initTmpList();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    openAddSalaryTmp() {
      this.clear();
      this.isFlag = 1;
      this.dialogTitle = "新增模板";
      this.dialogVisible = true;
    },

    openModSalaryTmp() {
      this.clear();
      this.isFlag = 6;
      this.dialogTitle = "编辑模板";
      this.form.tmpName = this.salaryTemplateName;
      this.form.thirdDeptment = this.groupId;
      this.dialogVisible = true;
    },

    /* 选择模板 */
    selectTag(index, row, e) {
      this.activeTypeIndex = 0;
      this.activeIndex = index;
      this.salaryTemplateId = row.id;
      this.salaryTemplateName = row.name;
      this.groupId = row.groupId;
      this.hangeTag(e)
      this.initSalaryTypeList();
    },

    /* 新增模板 */
    addSalaryTmp() {
      let templateId = "";
      let title = "模板新增成功";
      if (this.isFlag == 6) {
        title = "模板编辑成功";
        templateId = this.salaryTemplateId;
      }
      let data = {
        name: this.form.tmpName,
        groupId: this.form.thirdDeptment,
        templateId,
      };
      Salary.postSaveSalaryTmpList(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: title,
          });
          this.initTmpList();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 选择分类 */
    selectType(index, item) {
      this.activeTypeIndex = index;
      this.salaryCategoryId = item.id;
      this.tableData = this.treeToArray(item.itemList);
    },

    /* 树结构转为数组 */
    treeToArray(tree) {
      let arr = [];
      const expanded = (datas) => {
        if (datas && datas.length > 0) {
          datas.map((e) => {
            arr.push(e);
            expanded(e.contentList);
          });
        }
      };
      expanded(tree);

      let newArrIds = [];
      let newArr = [];
      arr.map((i) => {
        if (newArrIds.indexOf(i.contentId) == -1) {
          newArrIds.push(i.contentId);
          newArr.push(i);
        }
      });
      return newArr;
    },

    /* 限制为正整数 */
    inputAmount(v) {
      this.form.amount = inputTwoDecimal(v);
    },

    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value, command) {
      return {
        value: value,
        command: command,
      };
    },

    handleCommand(command) {
      switch (command.command) {
        case "mod":
          this.salaryCategoryId = command.value.id;
          this.form.typeName = command.value.name;
          this.isFlag = 3;
          this.dialogTitle = "重命名";
          this.dialogVisible = true;
          break;
        case "delete":
          this.salaryCategoryId = command.value.id;
          this.$confirm("分类删除后不可恢复，是否继续？", "确认删除分类", {
            confirmButtonText: "删除",
            cancelButtonText: "取消",
            confirmButtonClass: "btn-red",
            cancelButtonClass: "btn-gray",
          }).then(() => {
            this.delType();
          });
          break;
      }
    },

    /* 开启新增分类 */
    openAddType() {
      this.clear();
      this.isFlag = 2;
      this.dialogTitle = "新增分类";
      this.dialogVisible = true;
    },

    /* 新增分类 */
    addType() {
      let salaryTemplateId = this.salaryTemplateId;
      let ruleType = this.form.ruleType;
      let name = this.form.typeName;
      let data = {
        salaryTemplateId,
        ruleType,
        name,
      };
      Salary.postAddSalaryType(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "分类新增成功",
          });
          this.initSalaryTypeList();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 重命名分类 */
    modTypeName() {
      let salaryCategoryId = this.salaryCategoryId;
      let name = this.form.typeName;
      let data = {
        salaryCategoryId,
        name,
      };
      Salary.postModSalaryTypeName(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "重命名成功",
          });
          this.initSalaryTypeList();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 删除分类 */
    delType() {
      let salaryCategoryId = this.salaryCategoryId;
      let data = {
        salaryCategoryId,
      };
      Salary.postDelSalaryType(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.initSalaryTypeList();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 添加细项 */
    openAddDetail() {
      this.isModDetails = 0;
      this.drawer = true;
    },

    /* 修改细项 */
    mod(row) {
      this.isModDetails = 1;
      this.drawer = true;
      this.ruleForm.detailsName = row.name;
      this.ruleForm.detailsType = row.type;
      this.detailsId = row.id;
      if (row.type == "Customize")
        this.ruleForm.textarea =
          row.contentList.length > 0 ? row.contentList[0].content : "";
      if (row.type == "Label") this.ruleForm.unscrambleList = row.contentList;
    },

    /* 删除细项 */
    remove(id) {
      
      this.$confirm("细项删除后不可恢复，是否继续？", "确认删除细项", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-red",
        cancelButtonClass: "btn-gray",
      }).then(() => {
        let data = {
          id,
        };
        Salary.postDelDetails(data).then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.initSalaryTypeList();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    /* 添加解读内容 */
    addLabelTitle() {
      this.isFlag = 5;
      this.dialogTitle = "添加解读内容";
      this.dialogVisible = true;
    },

    /* 编辑解读内容 */
    modLabelTitle(item, index) {
      this.isFlag = 4;
      this.dialogTitle = "编辑解读内容";
      this.dialogVisible = true;
      this.form.content = item.content;
      this.form.amount = item.amount;
      this.unscrambleIndex = index;
    },

    delLabelTitle(index) {
      this.ruleForm.unscrambleList.splice(index, 1);
    },

    closeDrawer() {
      (this.ruleForm.detailsName = ""),
        (this.ruleForm.detailsType = "Label"),
        (this.ruleForm.textarea = ""),
        (this.ruleForm.unscrambleList = []);
      this.detailsId = "";
      this.unscrambleIndex = "";
      this.drawer = false;
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let id = this.detailsId;
          let salaryCategoryId = this.salaryCategoryId;
          let name = this.ruleForm.detailsName;
          let type = this.ruleForm.detailsType;
          let data = {
            id,
            name,
            type,
            salaryCategoryId,
          };
          if (this.ruleForm.detailsType == "Customize") {
            data.contentList = [
              {
                content: this.ruleForm.textarea,
                amount: 0,
              },
            ];
          } else {
            let arr = [];
            this.ruleForm.unscrambleList.map((i) => {
              let obj = {};
              obj.content = i.content;
              obj.amount = handleAmount(i.amount, 1);
              arr.push(obj);
            });
            data.contentList = arr;
          }

          Salary.postSaveDetails(data).then((res) => {
            if (res.success) {
              this.$message({
                type: "success",
                message: "保存成功",
              });
              // this.activeTypeIndex = 0
              this.closeDrawer();
              this.initSalaryTypeList();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    clear() {
      this.form.tmpName = "";
      this.form.thirdDeptment = "";
      this.form.typeName = "";
      this.form.ruleType = "";
      this.form.content = "";
      this.form.amount = "";
    },

    handleClose() {
      this.dialogVisible = false;
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isFlag == 1 || this.isFlag == 6) this.addSalaryTmp();
          if (this.isFlag == 2) this.addType();
          if (this.isFlag == 3) this.modTypeName();
          if (this.isFlag == 4) this.modLabelName();
          if (this.isFlag == 5) this.addLabelName();
          this.clear();
          this.handleClose();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /* 添加标签名称 */
    addLabelName() {
      let obj = {
        content: this.form.content,
        amount: this.form.amount,
      };
      this.ruleForm.unscrambleList.push(obj);
    },

    /* 修改标签名称 */
    modLabelName() {
      this.ruleForm.unscrambleList[this.unscrambleIndex].content =
        this.form.content;
      this.ruleForm.unscrambleList[this.unscrambleIndex].amount =
        this.form.amount;
    },

    pro() {
      let spanLeft = this.spanLeft
      // 获取最外层元素
      const scrollBox = document.getElementById('salarytmpname')
      if (spanLeft > 0 ) {
        this.spanLeft = spanLeft - 156
        scrollBox.scrollLeft = this.spanLeft
      }
    },

    next() {
      let spanLeft = this.spanLeft
      // 获取最外层元素
      const scrollBox = document.getElementById('salarytmpname')
      // 滚动条滚动距离
      const scroll = scrollBox.scrollLeft
      if (spanLeft > scroll ) {
        return this.spanLeft = scroll
      }
      this.spanLeft = spanLeft + 156
      scrollBox.scrollLeft = this.spanLeft
    },

    hangeTag(e) {
      // 当前点击元素的左边距离
      const spanLeft = e.clientX
      // 点击元素的宽度
      const divBox = 70
      // 屏幕总宽度
      const totalWidth = document.body.clientWidth
      // 屏幕总宽度的一半
      const width = totalWidth / 2
      // 元素的右边距离
      const spanRight = totalWidth - spanLeft
      // 获取最外层元素
      const scrollBox = document.getElementById('salarytmpname')
      // 滚动条滚动距离
      const scroll = scrollBox.scrollLeft
      if (spanLeft > 100 || spanRight < 100) {
        scrollBox.scrollLeft = scroll + (spanLeft - width) + divBox
        this.spanLeft = scrollBox.scrollLeft
      }
    }
  },
};
</script>

<style lang='scss'>
.salary-tmp {
  flex: 1;
  background: $bg-WhiteSmoke;
  .salary-tmp-content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .add-salary-tmp {
    height: 56px;
    background: $bg-white;
    @include flex-between;
    padding: 0px 20px;
    .el-icon-arrow-left,
    .el-icon-arrow-right {
      cursor: pointer;
    }
    #swiper {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }
    .salary-tmp-name {
      flex: 1;
      overflow: hidden;
      height: 100%;
      margin: 0px 10px;
    }
    .tmp-btn {
      width: 180px;
      margin-left: 20px;
    }
    .el-tag {
      cursor: pointer;
      background: transparent;
      border: none;
      color: $color-grey;
      font-weight: 400;
      font-size: $fs-medium-s;
      border-radius: 0px;
      .el-icon-close {
        top: -11px;
        right: 6px;
      }
    }
    .tag-name {
      width: 120px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical
    }
    .el-tag + .el-tag {
      margin-left: 10px;
    }
    .active {
      border-bottom: 1px solid $bg-DeepReddishBlue;
      color: $color-DepartmentPeople;
      width: 140px;
    }
  }
  .salary-tmp-container {
    flex: 1;
    background: $bg-white;
    margin: 20px 20px 0px 20px;
    display: flex;
    justify-content: center;
    .left-container {
      width: 288px;
      padding: 16px;
      box-sizing: border-box;
      border-right: 1px solid $bg-ShallowLightSnow;
      @include flex-column-center;
      .add-type-content {
        flex: 1;
        width: 256px;
        position: relative;
        overflow-y: auto;
        .search-type {
          margin-bottom: 16px;
        }
        .type {
          height: 40px;
          @include flex-between;
          padding: 0px 12px;
          cursor: pointer;
          .type-title {
            @include flex-start;
            font-size: $fs-small-l;
            font-weight: 400;
            color: $color-grey;
            img {
              width: 20px;
              height: 20px;
              margin-right: 16px;
            }
          }
        }
        .active {
          background: $bg-Tab;
          .type-title {
            color: $color-DeepReddishBlue;
          }
        }
      }
    }
    .add-type {
      width: 200px;
    }
    .right-container {
      flex: 1;
      padding: 28px 19px;
      .top-container {
        @include flex-between;
        margin-bottom: 20px;
        .title {
          padding-left: 10px;
          font-size: $fs-medium-s;
          color: $color-BlackGrey;
          border-left: 4px solid $color-DeepReddishBlue;
        }
        .search {
          display: flex;
          .add {
            margin-left: 12px;
            padding: 0;
          }
        }
      }
    }
  }
  .nothing {
    background: $bg-white;
    margin: 20px 20px 0px 20px;
    @include flex-center;
    .nothing-left {
      width: 503px;
      @include flex-column-start;
    }
    .nothing-title {
      font-size: 36px;
      font-weight: 400;
      color: #1d1e1e;
      margin-bottom: 37px;
    }
    .nothing-tips {
      font-size: $fs-small-l;
      font-weight: 400;
      color: $bg-grey;
      line-height: 22px;
      margin-bottom: 28px;
      text-align: left;
    }
    .tmp-nothing {
      width: 440px;
      height: 296px;
    }
    .tmpType-nothing {
      width: 410px;
      height: 316px;
    }
  }
  .sub-title {
    text-align: left;
    font-size: $fs-medium-s;
    font-weight: 400;
    margin-bottom: 25px;
    color: $color-Step;
  }
  .label-title {
    @include flex-between;
    font-size: $fs-small-l;
    font-weight: 400;
    margin-bottom: 25px;
    color: $color-grey;
    .add-label-title {
      cursor: pointer;
      color: $color-DepartmentPeople;
    }
  }
  .unscramble {
    width: 340px;
    height: 76px;
    margin-bottom: 14px;
    box-sizing: border-box;
    background: $bg-ChangeDepartmentTree;
    padding: 16px 12px 18px 12px;
    position: relative;
    text-align: left;
    font-size: $fs-small-l;
    font-family: SimSun;
    font-weight: 400;
    color: $color-grey;
    .el-icon-error {
      position: absolute;
      right: -8px;
      top: -8px;
      color: $color-ColdAsh;
    }
    .amount {
      margin-top: 16px;
      @include flex-between;
    }
  }
  .el-icon-edit,
  .el-icon-delete {
    cursor: pointer;
  }
  .el-icon-delete {
    margin-left: 20px;
  }
  .tmpType {
    margin: 0px;
  }
  .el-dropdown-link {
    @include extend-click;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after {
    content: "*";
    color: $bg-Required;
    margin-left: 4px;
  }
  .el-form-item__label {
    line-height: 30px;
  }
  .el-dialog__header,
  .el-dialog__footer {
    border: none;
  }
  .el-dialog__footer {
    @include flex-end;
  }
  .add-type {
    position: relative;
  }
  .tooltip {
    position: absolute;
    top: 93px;
    left: 70px;
    z-index: 9999;
  }
}
.mod {
  color: $color-grey;
  font-size: $fs-small-l;
}
.delete {
  color: $color-Crimson;
  font-size: $fs-small-l;
}
</style>
